/**
 * Curated media references used in hero sections and feature blocks.
 * Paths point at Storage objects defined in media.json.
 */
export const FEATURED = {
  /** Primary single hero clip (kept for fallback / other surfaces). */
  heroVideo: "media/videos/crosspan2.mp4",
  /** Hero poster — drives LCP, preloaded. Leads with the valley view. */
  heroPoster: "media/house-photos/view-from-cross-area.jpg",
  /**
   * Scenic vista montage — leads with the experience, not interiors:
   * valley view → ceremony space → pool → hillside waterfall.
   */
  heroMontage: [
    "media/videos/crosspan2.mp4", // panoramic valley view
    "media/videos/crosspan3.mp4", // outdoor ceremony / cross area
    "media/videos/housepoolpano.mp4", // resort-style pool
    "media/videos/waterfall1.mp4", // hillside waterfall
  ],
  ceremony: "media/house-photos/eagle-view-of-ceremony-space.jpg",
  ceremonyDecks: "media/house-photos/lower-ceremony-decks.jpg",
  pool: "media/house-photos/pool-area.jpg",
  living: "media/house-photos/living-room.jpg",
  gameRoom: "media/house-photos/game-room-1.jpg",
  masterBedroom: "media/house-photos/master-bedroom-1.jpg",
  balconyView: "media/house-photos/master-bedroom-balcony-view.jpg",
  kitchen: "media/house-photos/kitchen-1.jpg",
  frontHome: "media/house-photos/front-of-home-1.jpg",
  diningRoom: "media/house-photos/dining-room.jpg",
  crossView: "media/house-photos/view-from-cross-area.jpg",
  frontCross: "media/house-photos/front-cross-area.jpg",
  /** Pool / spa / outdoor-living video for the experience section. */
  poolVideo: "media/videos/walkwaytopool.mp4",
  /**
   * Curated "best of" set for the homepage gallery preview — lead with the
   * view, ceremony, pool and emotional moments; never the nook or random shots.
   */
  bestPhotos: [
    "media/house-photos/eagle-view-of-ceremony-space.jpg",
    "media/house-photos/view-from-cross-area.jpg",
    "media/house-photos/pool-area.jpg",
    "media/house-photos/lower-ceremony-decks.jpg",
    "media/house-photos/master-bedroom-balcony-view.jpg",
    "media/house-photos/front-cross-area.jpg",
  ],
} as const;
